import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';

const appFont = "'Arial', 'Helvetica Neue', sans-serif";
const instagramUrl = 'https://www.instagram.com/flyshitnyc/?hl=en';
const instagramDmUrl = 'https://ig.me/m/flyshitnyc';

const homeSlides = [
 {
  src: '/assets/home-slides/flyshit-slide-1.png',
  alt: 'About us slide: Flyshitnyc is more than dressing fly, it is living a fly lifestyle.',
 },
 {
  src: '/assets/home-slides/flyshit-slide-2.png',
  alt: 'Vision, mission, and what we believe slide.',
 },
 {
  src: '/assets/home-slides/flyshit-slide-3.png',
  alt: 'Reviews slide with quotes from By Tianna Osbourne and Ebsarr.',
 },
 {
  src: '/assets/home-slides/flyshit-slide-4.png',
  alt: 'Our services slide: creative direction, film photography, model scouting, and send us a message.',
  href: instagramDmUrl,
 },
];

function InstagramHandle({ className = '' }) {
 return (
  <a
   className={`flyshit-instagram-link ${className}`}
   href={instagramUrl}
   target="_blank"
   rel="noopener noreferrer"
   aria-label="Open FlyShitNYC on Instagram"
  >
   @flyshitnyc
  </a>
 );
}

export default function Home() {
 return (
  <div className="flyshit-home-page flyshit-deck-home" style={{ fontFamily: appFont }}>
   <Navbar theme="dark" />

   <main>
    <section className="flyshit-deck-hero" aria-labelledby="flyshit-home-title">
     <div className="flyshit-deck-hero__topline">Lifestyle | Fashion | Community | Shop</div>

     <div className="flyshit-deck-hero__headline" id="flyshit-home-title" aria-label="Fly Shit NYC">
      <span>FLY</span>
      <span>SH</span>
      <span className="flyshit-deck-hero__spark" aria-hidden="true">✱</span>
      <span>T</span>
      <span>NYC</span>
     </div>

     <img className="flyshit-deck-hero__pigeon" src="/assets/flyshit-pigeon.png" alt="FlyShitNYC pigeon mascot wearing a fitted cap and boots" />

     <div className="flyshit-deck-hero__bottom">
      <p>Where brands become culture</p>
      <InstagramHandle />
     </div>
    </section>

    <section id="about" className="flyshit-home-slide-scroll" aria-label="FlyShitNYC brand deck slides">
     {homeSlides.map((slide) => (
      <article key={slide.src} className="flyshit-home-slide-panel">
       {slide.href ? (
        <a href={slide.href} target="_blank" rel="noopener noreferrer" aria-label="Send FlyShitNYC a message on Instagram">
         <img src={slide.src} alt={slide.alt} />
        </a>
       ) : (
        <img src={slide.src} alt={slide.alt} />
       )}
      </article>
     ))}
    </section>

    <section className="flyshit-deck-cta flyshit-deck-cta--simple">
     <div>
      <p className="flyshit-deck-kicker">Stay connected</p>
      <h2>Tap in with <InstagramHandle className="flyshit-instagram-link--inline" /> and keep up with the movement.</h2>
     </div>
     <div className="flyshit-deck-cta__buttons">
      <Link to="/shop" className="flyshit-home-button flyshit-home-button--primary">
       <span>Shop Now</span>
       <span aria-hidden="true">→</span>
      </Link>
      <Link to="/articles" className="flyshit-home-button flyshit-home-button--outline-dark">
       <span>Read Articles</span>
       <span aria-hidden="true">→</span>
      </Link>
     </div>
    </section>
   </main>

   <footer id="contact" className="flyshit-footer flyshit-deck-footer">
    <div>
     <div className="flyshit-footer__wordmark">FLY$HITNYC</div>
     <p>Where brands become culture.</p>
    </div>
    <div>
     <h3>Quick Links</h3>
     <Link to="/shop">Shop</Link>
     <Link to="/articles">Articles</Link>
     <a href="/#about">About</a>
     <a href="/#contact">Contact</a>
    </div>
    <div>
     <h3>Services</h3>
     <span>Creative Direction</span>
     <span>Film Photography</span>
     <span>Model Scouting</span>
    </div>
    <div>
     <h3>Instagram</h3>
     <InstagramHandle className="flyshit-instagram-link--footer" />
    </div>
    <small>© 2026 FlyShitNYC. All Rights Reserved.</small>
   </footer>
  </div>
 );
}
